import React from "react";

import styles from "./InteractiveSvg.module.scss";

export const SvgContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.svgContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Svg: React.FC<React.SVGAttributes<SVGSVGElement>> = ({
  className,
  children,
  ...rest
}) => (
  <svg className={`${styles.svg} ${className ?? ""}`} {...rest}>
    {children}
  </svg>
);

export const SvgPointer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.svgPointer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
